import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/coach_badge_negative.png")